define('models/marketplace',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.Marketplace = T1Model.extend({
    url: "marketplaces/"
  });
  return T1.Models.Marketplace;
});
